import React, { Component } from 'react';
import './App.css';

import Navbar from './components/navbar/Navbar';
import Jumbotron from './components/jumbotron/Jumbotron';
import DevJourney from './components/devJourney/DevJourney';
import DevHack from './components/devHack/DevHack'
import Coordenacao from './components/coordenacao/Coordenacao';
import Cronograma from './components/cronograma/Cronograma';
import Footer from './components/footer/Footer';

class App extends Component {
  render() {
    return (
      <React.Fragment>
        <Navbar></Navbar>
        <Jumbotron></Jumbotron>
        <DevJourney></DevJourney>
        <DevHack></DevHack>
        <Coordenacao></Coordenacao>
        <Cronograma></Cronograma>
        <Footer></Footer>
      </React.Fragment>
    );
  }
}

export default App;
